import React, { useState } from "react";
import { Modal } from "react-bootstrap";

import { unLinkFb } from "../../../model/profile";
import { commonErr } from "../../common/errors";

import { IcUnLink } from "../../common/svg";

const UnLinkFacebook = (props) => {
	const [state, setState] = useState({
		step: 0, //0: show button 1: show confirm 2: show unlink result
		isShowModal: false,
		err: commonErr.INNIT,
		errMsg: "",
	});

	const onBtnUnLinkFbClick = () => {
		setState({
			...state,
			isShowModal: true,
			step: 1,
		});
	};

	const onContinueBtnClick = () => {
		unLinkFb().then((resp) => {
			setState({
				...state,
				step: 2,
				err: resp.data.error,
				errMsg: resp.data.errorMessage,
			});
		});
	};

	const onFinishBtnClick = () => {
		setState({
			...state,
			isShowModal: false,
		});
		if (state.err >= commonErr.SUCCESS) {
			props.getProfile();
		}
	};

	const hideModal = () => {
		setState({
			step: 0,
			isShowModal: false,
			err: commonErr.INNIT,
			errMsg: "",
		});
		if (state.step === 2 && state.err >= commonErr.SUCCESS) {
			props.getProfile();
		}
	};

	const ModalContent = () => {
		if (state.step === 1) {
			return (
				<div className="modal-confirm-body confirm-inner">
					<p className="font-14">Bạn có chắc muốn bỏ liên kết tài khoản của mình với tài khoản Facebook hiện tại?</p>
					<a className="btn btn-primary btn--m" type="button" onClick={onContinueBtnClick}>
						Tiếp tục
					</a>
				</div>
			);
		} else {
			return (
				<div className="modal-confirm-body confirm-inner">
					{state.err >= commonErr.SUCCESS ? (
						<p className="font-14">Bỏ liên kết tài khoản thành công</p>
					) : (
						<p className="font-14">Bỏ liên kết thất bại. {state.errMsg}</p>
					)}
					<a className="btn btn-primary btn--m" type="button" onClick={onFinishBtnClick}>
						Hoàn tất
					</a>
				</div>
			);
		}
	};

	return (
		<div className="name">
			<div className="wrap-svg" onClick={onBtnUnLinkFbClick}>
				<IcUnLink />
			</div>

			<Modal show={state.isShowModal} onHide={hideModal} dialogClassName="modal-s modal-confirm">
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>Xác nhận</h5>
				</Modal.Header>
				<Modal.Body>{ModalContent()}</Modal.Body>
			</Modal>
		</div>
	);
};

export default UnLinkFacebook;
